import { ENTITY_ROLES } from "../utils/sidebarStorage";

export function getMerchantSections(entityRole) {
  return [
    {
      title: "Business Account",
      items: [
        { name: "Overview", label: "Sales Overview" },
        { name: "sales-transactions", label: "Sales Transactions" },
        ...(entityRole !== ENTITY_ROLES.supervisor
          ? [{ name: "EOD Closing" }]
          : []),
      ],
    },
    {
      title: "Transactions",
      items: [
        { name: "Payment Request" },
        { name: "External Cash Deposit" },
      ],
    },
    {
      title: "Settings",
      items: [
        { name: "Merchant Information" },
        { name: "Branches" },
        ...(entityRole !== ENTITY_ROLES.supervisor
          ? [{ name: "Employees" }]
          : []),
      ],
    },
  ];
}
